import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';

function OverParkedTable(props){
    const {overParkedData, garageName} = props

    return (

        <Table striped bordered className='report table-sm table__data'>
        <thead>
            <tr className='table-warning'>
                <th>Type</th>
                <th>Ticket #/FOB</th>
                <th>Parked In</th>
                <th>Total Days In Garage</th>
            </tr>
        </thead>
        <tbody>
        {
            overParkedData.map((data, index)=>{
                return(
                <tr key={index}>
                    <td>{data.Type}</td>
                    {
                        data.Type == 'T' ?
                        <td>{data.FOB}</td>
                        :
                        <td><Link to={`/reportSelect/${garageName}/daily/carDetails/${data.FOB}`}>{data.FOB}</Link></td>

                    }
                    
                    <td>{data.InDateTime}</td>
                    <td>{data.TotalDays}</td>
                </tr>
                )
            })
        }
        </tbody>
        </Table>
        
    )
}

export default OverParkedTable;